export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#1B2E26] text-[#E9E4DA] overflow-hidden"
    >
      {/* Decorative top edge */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#E9E4DA]/30 to-transparent" />

      <div className="mx-auto max-w-[1320px] px-6 md:px-10 lg:px-16 pt-20 md:pt-20 pb-10">
        {/* Headline block */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 pb-16 md:pb-20 border-b border-[#E9E4DA]/15">
          <div className="lg:col-span-7">
            <p className="text-[10px] uppercase tracking-[0.28em] text-[#E9E4DA]/60">
              Dr. Chandril Ghosh
            </p>
            <p className="mt-5 font-serif-display text-2xl md:text-3xl lg:text-[2.5rem] leading-[1.15] tracking-[-0.02em] text-[#FDFBF7] font-medium max-w-2xl">
              A quieter, steadier kind of{" "}
              <em className="italic font-normal text-[#E9E4DA]">change</em>.
            </p>
          </div>
          <div className="lg:col-span-5 lg:pt-3 flex flex-col gap-5">
            <a
              href="tel:07501211348"
              data-testid="footer-cta-phone"
              className="group flex items-center justify-between gap-4 border border-[#E9E4DA]/30 hover:border-[#E9E4DA] text-[#FDFBF7] px-6 py-5 transition-colors"
            >
              <span className="text-[10px] uppercase tracking-[0.28em] text-[#E9E4DA]/70">
                Call
              </span>
              <span className="font-serif-display text-xl md:text-2xl">
                07501 211 348
              </span>
            </a>
            <a
              href="mailto:ghoshchandril@gmail.com"
              data-testid="footer-cta-email"
              className="group flex items-center justify-between gap-4 border border-[#E9E4DA]/30 hover:border-[#E9E4DA] text-[#FDFBF7] px-6 py-5 transition-colors"
            >
              <span className="text-[10px] uppercase tracking-[0.28em] text-[#E9E4DA]/70">
                Email
              </span>
              <span className="font-serif-display text-lg md:text-xl break-all">
                ghoshchandril@gmail.com
              </span>
            </a>
          </div>
        </div>

        {/* Detail columns */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 pt-16 md:pt-20">
          <div className="md:col-span-4">
            <p className="text-[10px] uppercase tracking-[0.28em] text-[#E9E4DA]/60">
              Practice
            </p>
            <p className="mt-5 font-serif-display text-xl text-[#FDFBF7] leading-snug">
              Dr. Chandril Ghosh
            </p>
            <p className="mt-2 text-sm leading-relaxed text-[#E9E4DA]/75">
              Clinical Psychologist · Nottingham &amp; Online UK
            </p>
            <p className="mt-5 text-sm leading-relaxed text-[#E9E4DA]/65 max-w-xs">
              CBT, ACT &amp; CFT with a relational and attachment-informed
              focus. Accepting a limited number of new adult patients.
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="text-[10px] uppercase tracking-[0.28em] text-[#E9E4DA]/60">
              Credentials &amp; Registrations
            </p>
            <ul className="mt-5 space-y-5 text-sm leading-relaxed">
              <li>
                <span className="block text-[#E9E4DA]/65 text-[11px] uppercase tracking-[0.2em]">
                  HCPC Registered Clinical Psychologist
                </span>
                <span className="text-[#FDFBF7]">PYL045683</span>
              </li>
              <li>
                <span className="block text-[#E9E4DA]/65 text-[11px] uppercase tracking-[0.2em]">
                  BPS Chartered Member
                </span>
                <span className="text-[#FDFBF7]">546878</span>
              </li>
              <li>
                <span className="block text-[#E9E4DA]/65 text-[11px] uppercase tracking-[0.2em]">
                  ICO Registered Data Controller
                </span>
                <span className="text-[#FDFBF7]">ZB984279</span>
              </li>
              <li>
                <span className="block text-[#E9E4DA]/65 text-[11px] uppercase tracking-[0.2em]">
                  Approved Insurance Provider
                </span>
                <span className="text-[#FDFBF7]">AXA · Aviva · Bupa · WPA · Vitality</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[10px] uppercase tracking-[0.28em] text-[#E9E4DA]/60">
              Registered Office
            </p>
            <address
              data-testid="footer-registered-address"
              className="mt-5 not-italic text-sm leading-relaxed text-[#FDFBF7]"
            >
              <span className="block text-[11px] uppercase tracking-[0.18em] text-[#E9E4DA]/65">
                National Centre for
                <br />
                Evidence-Based Mental Health Ltd
              </span>
              <span className="mt-3 block text-[#E9E4DA]/85 leading-[1.7]">
                5 South Charlotte Street
                <br />
                Edinburgh, EH2 4AN
                <br />
                Scotland, United Kingdom
              </span>
            </address>
            <p
              data-testid="footer-company-reg"
              className="mt-5 text-[11px] uppercase tracking-[0.2em] text-[#E9E4DA]/60"
            >
              Registered in Scotland · Company No.{" "}
              <span className="text-[#FDFBF7]">SC850353</span>
            </p>
          </div>
        </div>

        {/* Trading-name disclosure */}
        <div className="mt-16 md:mt-20 pt-8 border-t border-[#E9E4DA]/15">
          <p
            data-testid="footer-trading-disclosure"
            className="text-sm leading-relaxed text-[#E9E4DA]/75 max-w-3xl"
          >
            <span className="text-[#FDFBF7]">Chandril Ghosh</span> is a trading
            name of{" "}
            <span className="text-[#FDFBF7]">
              National Centre for Evidence-Based Mental Health Limited
            </span>
            .
          </p>
        </div>

        {/* Crisis reminder strip */}
        <div className="mt-10 bg-[#FDFBF7]/[0.04] border border-[#E9E4DA]/15 px-6 py-5">
          <p className="text-xs md:text-sm leading-relaxed text-[#E9E4DA]/80">
            <span className="text-[#FDFBF7] uppercase tracking-[0.18em] text-[10px] md:text-[11px] mr-3">
              Important
            </span>
            This website is informational and is not a substitute for emergency
            care. In a crisis, call <a href="tel:999" className="link-underline text-[#FDFBF7]">999</a>,
            or Samaritans on <a href="tel:116123" className="link-underline text-[#FDFBF7]">116 123</a>.
          </p>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-[#E9E4DA]/15 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <p
            data-testid="footer-copyright"
            className="text-xs text-[#E9E4DA]/65"
          >
            © 2026 National Centre for Evidence-Based Mental Health Ltd. All
            rights reserved.
          </p>
          <nav
            data-testid="footer-legal-nav"
            className="flex flex-wrap items-center gap-x-7 gap-y-3 text-xs"
          >
            <a
              href="https://gettermscdn.com/view/4fRA2/terms-of-service/en-au"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-terms-link"
              className="link-underline text-[#FDFBF7]"
            >
              Terms of Service
            </a>
            <a
              href="https://gettermscdn.com/view/4fRA2/privacy/en-au"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-privacy-link"
              className="link-underline text-[#FDFBF7]"
            >
              Privacy Policy
            </a>
            <a
              href="https://gettermscdn.com/view/4fRA2/cookies/en-au"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-cookies-link"
              className="link-underline text-[#FDFBF7]"
            >
              Cookie Policy
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
};
